// Domain types for the Project Attachments MSPA.

export type ProjectAttachmentTab = "active" | "archived";

// Allowed upload extensions, mirrored from the Rails
// AttachmentUploader.extension_allowlist (svg intentionally excluded).
export const ALLOWED_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "bmp",
  "tif",
  "tiff",
  "webp",
  "heic",
  "pdf",
  "txt",
  "csv",
  "rtf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "odt",
  "ods",
  "odp",
  "vsd",
  "vsdx",
] as const;

export const fileExtension = (filename: string): string =>
  filename.split(".").pop()?.toLowerCase() ?? "";

export const isAllowedFile = (file: File): boolean =>
  (ALLOWED_EXTENSIONS as readonly string[]).includes(fileExtension(file.name));

// A row in the attachments list table.
export interface ProjectAttachment {
  id: string;
  document: string; // filename
  active: boolean;
  attachmentTypeId: string | null;
  attachmentTypeName: string; // "" when none
}

// Controlled values for the create/edit form.
export interface ProjectAttachmentFormValues {
  attachmentTypeId: string; // "" = none
  file: File | null; // required on New, optional (replace) on Edit
}

export const emptyProjectAttachmentForm: ProjectAttachmentFormValues = {
  attachmentTypeId: "",
  file: null,
};
